module.exports = __webpack_public_path__ + "static/media/mark-7.jpeg";